module.exports = __webpack_public_path__ + "static/hindi-widgets-30c6e9f5d2d94780166a07b3415f1b27.png";